(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;

  var overlay = header.querySelector('[data-menu-overlay]');
  var activePanel = null;

  function showOverlay() {
    if (!overlay) return;
    overlay.hidden = false;
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
  }
  function hideOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    window.setTimeout(function () {
      if (!activePanel) overlay.hidden = true;
    }, 320);
  }

  function openPanel(panel, opts) {
    opts = opts || {};
    if (activePanel && activePanel.el !== panel.el) closePanel();
    activePanel = panel;
    panel.el.hidden = false;
    void panel.el.offsetWidth;
    panel.el.classList.add('is-open');
    if (panel.toggle) panel.toggle.setAttribute('aria-expanded', 'true');
    showOverlay();
    document.body.style.overflow = 'hidden';
    if (opts.focus) {
      var f = panel.el.querySelector(opts.focus);
      if (f) f.focus();
    }
  }

  function closePanel() {
    if (!activePanel) return;
    var panel = activePanel;
    activePanel = null;
    panel.el.classList.remove('is-open');
    if (panel.toggle) panel.toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    hideOverlay();
    window.setTimeout(function () {
      if (activePanel !== panel) panel.el.hidden = true;
    }, 340);
  }

  if (overlay) overlay.addEventListener('click', closePanel);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanel();
  });

  /* ---------- Menu drawer ---------- */
  var menuToggle = header.querySelector('[data-menu-toggle]');
  var menuDrawer = header.querySelector('[data-menu-drawer]');
  var menuClose = header.querySelector('[data-menu-close]');
  if (menuToggle && menuDrawer) {
    var menuPanel = { el: menuDrawer, toggle: menuToggle };
    menuToggle.addEventListener('click', function () {
      if (activePanel && activePanel.el === menuDrawer) closePanel();
      else openPanel(menuPanel, { focus: 'a' });
    });
    if (menuClose) menuClose.addEventListener('click', closePanel);
    window.matchMedia('(min-width: 900px)').addEventListener('change', function (e) {
      if (e.matches && activePanel && activePanel.el === menuDrawer) closePanel();
    });
  }

  /* ---------- Search panel ---------- */
  var searchToggle = header.querySelector('[data-search-toggle]');
  var searchPanel = header.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    var sPanel = { el: searchPanel, toggle: searchToggle };
    var input = searchPanel.querySelector('[data-search-input]');
    var results = searchPanel.querySelector('[data-search-results]');
    var searchClose = searchPanel.querySelector('[data-search-close]');
    var debounce;

    searchToggle.addEventListener('click', function () {
      if (activePanel && activePanel.el === searchPanel) closePanel();
      else openPanel(sPanel, { focus: '[data-search-input]' });
    });
    if (searchClose) searchClose.addEventListener('click', closePanel);

    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        window.clearTimeout(debounce);
        if (q.length < 2) {
          if (results) { results.hidden = true; results.innerHTML = ''; }
          return;
        }
        debounce = window.setTimeout(function () { predictive(q); }, 240);
      });
    }

    function predictive(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!results) return;
          if (!products.length) {
            results.innerHTML = '<p class="header__search-empty">Nema rezultata za “' + escapeHtml(q) + '”.</p>';
            results.hidden = false;
            return;
          }
          results.innerHTML = products.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            var thumb = img
              ? '<img class="header__search-thumb" src="' + img + '" alt="" loading="lazy">'
              : '<span class="header__search-thumb"></span>';
            var price = p.price ? '<span class="header__search-price">' + p.price + '</span>' : '';
            return '<a class="header__search-result" href="' + p.url + '">' + thumb +
              '<span class="header__search-info"><span class="header__search-name">' +
              escapeHtml(p.title) + '</span>' + price + '</span></a>';
          }).join('');
          results.hidden = false;
        })
        .catch(function () {});
    }
  }

  /* ---------- Cart drawer ---------- */
  var cartToggle = header.querySelector('[data-cart-toggle]');
  var cartDrawer = header.querySelector('[data-cart-drawer]');
  if (cartDrawer) {
    var cPanel = { el: cartDrawer, toggle: cartToggle };
    var body = cartDrawer.querySelector('[data-cart-body]');
    var footer = cartDrawer.querySelector('[data-cart-footer]');
    var emptyEl = cartDrawer.querySelector('[data-cart-empty]');
    var subtotalEl = cartDrawer.querySelector('[data-cart-subtotal]');
    var cartClose = cartDrawer.querySelector('[data-cart-close]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    var moneyFormat = cartDrawer.getAttribute('data-money-format') || '{{amount}}';
    var loaded = false;

    if (cartToggle) {
      cartToggle.addEventListener('click', function () {
        if (activePanel && activePanel.el === cartDrawer) { closePanel(); return; }
        openPanel(cPanel);
        renderCart();
      });
    }
    if (cartClose) cartClose.addEventListener('click', closePanel);

    function updateCount(count) {
      countEls.forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    function renderCart() {
      cartDrawer.classList.add('is-loading');
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          loaded = true;
          updateCount(cart.item_count);
          if (cart.item_count === 0) {
            if (body) body.hidden = true;
            if (footer) footer.hidden = true;
            if (emptyEl) emptyEl.hidden = false;
            cartDrawer.classList.remove('is-loading');
            return;
          }
          if (emptyEl) emptyEl.hidden = true;
          if (body) body.hidden = false;
          if (footer) footer.hidden = false;
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, moneyFormat);
          if (body) {
            body.innerHTML = cart.items.map(function (item, i) {
              var line = i + 1;
              var img = item.image
                ? '<img class="header__cart-thumb" src="' + item.image + '" alt="" loading="lazy">'
                : '<span class="header__cart-thumb"></span>';
              var variant = (item.variant_title && item.variant_title !== 'Default Title')
                ? '<span class="header__cart-variant">' + escapeHtml(item.variant_title) + '</span>' : '';
              return '<div class="header__cart-item" data-line="' + line + '">' + img +
                '<div class="header__cart-details">' +
                '<a class="header__cart-name" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
                variant +
                '<div class="header__cart-line-bottom">' +
                '<span class="header__cart-stepper">' +
                '<button class="header__cart-qty-btn" type="button" data-change="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="−">−</button>' +
                '<span class="header__cart-qty">' + item.quantity + '</span>' +
                '<button class="header__cart-qty-btn" type="button" data-change="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="+">+</button>' +
                '</span>' +
                '<span class="header__cart-price">' + formatMoney(item.final_line_price, moneyFormat) + '</span>' +
                '</div>' +
                '<button class="header__cart-remove" type="button" data-change="' + line + '" data-qty="0">Ukloni</button>' +
                '</div></div>';
            }).join('');
          }
          cartDrawer.classList.remove('is-loading');
        })
        .catch(function () { cartDrawer.classList.remove('is-loading'); });
    }

    // qty change / remove (event delegation)
    if (body) {
      body.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-change]');
        if (!btn) return;
        changeLine(btn.getAttribute('data-change'), btn.getAttribute('data-qty'));
      });
    }

    function changeLine(line, qty) {
      cartDrawer.classList.add('is-loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
      }).then(function () { renderCart(); })
        .catch(function () { cartDrawer.classList.remove('is-loading'); });
    }

    // Intercept add-to-cart forms across the theme
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action$="/cart/add"], form[action*="/cart/add"]')) return;
      // let variant-less / non-add forms pass
      if (!form.querySelector('[name="id"]')) return;
      // "Buy now" / checkout button should go straight to checkout, not the drawer
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();
      var data = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (submitBtn) submitBtn.disabled = false;
          openPanel(cPanel);
          renderCart();
        })
        .catch(function () { if (submitBtn) submitBtn.disabled = false; });
    });
  }

  /* ---------- helpers ---------- */
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(re);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(re, value);
  }
})();
